/**
 * items: GroupCheckbox's items    state object + array(필수)
 *     ex) 
		const [groupChecks, setGroupChecks] = React.useState({
			check1: false,
			check2: false,
			check3: false,
		});
		const groupCheckArray = [ 
			{
				name: "InGi",
				checked: groupChecks.check1,
				onChange: (e) => {
					setGroupChecks({ ...groupChecks, check1: e.target.checked });
				},
			},
			{
				name: "MiGyung",
				checked: groupChecks.check2,
				onChange: (e) => {
					setGroupChecks({ ...groupChecks, check2: e.target.checked });
				},
			},
			{
				name: "SeungChul",
				checked: groupChecks.check3,
				onChange: (e) => {
					setGroupChecks({ ...groupChecks, check3: e.target.checked });
				},
				disabled: true,
			},
		]
 * containerStyle: GroupCheckbox's containerStyle    object
 * inputStyle: GroupCheckbox's inputStyle    object
 * labelStyle: GroupCheckbox's labelStyle    object
 * gubun: GroupCheckbox's gubun    string or number
 * 
 */

import React from "react";

function GroupCheckbox({
	items,
	containerStyle,
	inputStyle,
	labelStyle,
	gubun,
}) {
	return (
		<>
			{items.map((item, index) => {
				return (
					<div key={index} style={containerStyle}>
						<input
							id={"groupCheckboxinput" + index + gubun}
							style={inputStyle}
							type="checkbox"
							checked={item.value}
							onChange={(e) => {
								item.onChange(e);
							}}
							disabled={item.disabled}
						/>
						<label
							style={labelStyle}
							htmlFor={"groupCheckboxinput" + index + gubun}
						>
							{item.name}
						</label>
					</div>
				);
			})}
		</>
	);
}

GroupCheckbox.defaultProps = {
	containerStyle: {
		margin: "0 5px",
	},
	inputStyle: {},
	labelStyle: {
		margin: "0 5px",
		fontSize: "15px",
		fontFamily: "s-core-dream-Medium",
	},
	gubun: 0,
};

export default GroupCheckbox;
